import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a7eaf6fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "indexlayout-main-conent" }
const _hoisted_2 = { class: "box-title" }
const _hoisted_3 = { class: "serve-info" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "serve-title" }, "服务说明", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.destinationName) + "标准服务", 1),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conData, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "serve-info-item",
              key: item
            }, [
              _createElementVNode("div", null, _toDisplayString(item.title), 1),
              (item.title == '上门揽收范围' || item.title == '客户自送范围')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (item.title == '上门揽收范围')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" 详见"),
                          _createVNode(_component_router_link, {
                            style: {"margin-left":"5px"},
                            to: "/home/collectionInfo"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("上门揽收范围")
                            ]),
                            _: 1
                          }),
                          _createTextVNode("； ")
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" 详见"),
                          _createVNode(_component_router_link, {
                            style: {"margin-left":"5px"},
                            to: "/home/selfdeliveryInfo"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("客户自送范围")
                            ]),
                            _: 1
                          }),
                          _createTextVNode("； ")
                        ], 64))
                  ]))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    innerHTML: item.explanation
                  }, null, 8, _hoisted_6))
            ]))
          }), 128))
        ])
      ]),
      _: 1
    })
  ]))
}